"use strict";

angular.module("models").service("ElearningLinksService", ["ApiService", function (ApiService) {
  var that = this;

  angular.extend(that, ApiService.getModel("elearningLinks", [], function (element) {
    return "???";
  }));
}]);